import { cn } from '@/lib/utils';

/** The app's home-screen icon (the favicon), as shown on the phone. */
export function AppIcon({ className }: { className?: string }) {
  // eslint-disable-next-line @next/next/no-img-element
  return <img src="/icons/maskable-192.png" alt="" width={48} height={48} className={cn('shrink-0 rounded-[22%] shadow-lg shadow-black/40', className)} />;
}
